var FullscreenService_1;
import { __decorate } from "tslib";
import screenfullUtil from '@/infrastructure/utils/screenfull';
import { provide } from '@/inversify.config';
export const FullscreenServiceSymbol = Symbol.for('FullscreenService');
const screenfull = screenfullUtil;
let FullscreenService = class FullscreenService {
    constructor() {
        this.active = false;
        this.enable = screenfull.isEnabled;
        this.handleFullscreenchange = () => {
            this.active = screenfull.isFullscreen;
            this.render();
        };
    }
    static { FullscreenService_1 = this; }
    static { this.FULLSCREEN_CLASS_NAME = 'full-screen-mode'; }
    init() {
        if (!screenfull.isEnabled) {
            this.active = false;
            return console.warn('浏览器不支持全屏API');
        }
        screenfull.on('change', this.handleFullscreenchange);
        this.handleFullscreenchange();
    }
    render() {
        if (this.active) {
            document.body.classList.add(FullscreenService_1.FULLSCREEN_CLASS_NAME);
        }
        else {
            document.body.classList.remove(FullscreenService_1.FULLSCREEN_CLASS_NAME);
        }
        setTimeout(() => {
            window.Bus.$emit('SpaceDetail:ExcelGrid:RefreshDimensions');
        }, 0);
    }
    enter() {
        return screenfull.request(document.body);
    }
    exit() {
        return screenfull.exit();
    }
    toggle() {
        if (this.active) {
            return this.exit();
        }
        return this.enter();
    }
    destroy() {
        if (!screenfull.isEnabled)
            return;
        this.active = false;
        this.render();
        screenfull.off('change', this.handleFullscreenchange);
    }
};
FullscreenService = FullscreenService_1 = __decorate([
    provide(FullscreenServiceSymbol)
], FullscreenService);
export { FullscreenService };
